import { render, staticRenderFns } from "./Fjfxy.vue?vue&type=template&id=66b44746&"
import script from "./Fjfxy.vue?vue&type=script&lang=js&"
export * from "./Fjfxy.vue?vue&type=script&lang=js&"
import style0 from "./Fjfxy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports